import { render, staticRenderFns } from "./document-input-component.vue?vue&type=template&id=73e84a11"
import script from "./document-input-component.vue?vue&type=script&setup=true&lang=js"
export * from "./document-input-component.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports